import { forwardRef, useEffect, useState } from "react";
import { useNavigate } from "hooks/useCustomNavigation";
import { useSearchBrands } from "./utils/useSearchBrands";
import { useDebouncedValue } from "hooks/useDebouncedValue";
import { SearchBrandsInputHome, SearchBrandsInputNavbar } from "..";

export const SearchBrandsInput = forwardRef(
  (
    {
      variant,
      placeholder,
      searchButtonLabel,
      onBrandsChange,
      onInputBlur,
      shouldShowDropdown
    },
    ref
  ) => {
    const [inputValue, setInputValue] = useState("");
    const { debouncedValue } = useDebouncedValue({ value: inputValue });
    const { brands, getBrands, getFirstSearch } = useSearchBrands();
    const navigate = useNavigate();

    const handleFormSubmit = async (e) => {
      e.preventDefault();
      const search = new FormData(e.target).get("search");

      const brand = await getFirstSearch(search);
      if (brand) navigate(brand.path);
    };

    const handleInputBlur = () => {
      setTimeout(() => shouldShowDropdown(false), 200);
      if (onInputBlur) onInputBlur();
    };

    useEffect(() => {
      getBrands(debouncedValue);
    }, [debouncedValue, getBrands]);

    useEffect(() => {
      onBrandsChange(brands);
    }, [brands, onBrandsChange]);

    const handleInputChange = (e) => setInputValue(e.target.value);
    const handleInputFocus = () => shouldShowDropdown(true);

    if (variant === "desktop")
      return (
        <SearchBrandsInputHome
          placeholder={placeholder}
          onInputChange={handleInputChange}
          onInputFocus={handleInputFocus}
          onInputBlur={handleInputBlur}
          onFormSubmit={handleFormSubmit}
          ref={ref}
        />
      );

    if (variant === "navbar")
      return (
        <SearchBrandsInputNavbar
          searchButtonLabel={searchButtonLabel}
          placeholder={placeholder}
          onInputChange={handleInputChange}
          onInputFocus={handleInputFocus}
          onInputBlur={handleInputBlur}
          onFormSubmit={handleFormSubmit}
          ref={ref}
        />
      );
  }
);
